export const UTILITIES_LAYER_TYPE_ID = "UTILITIES_LAYER_TYPE_ID";
export const MOCK_BUFFER_METERS = 30;
